import { RoleManagementEntityModel } from "src/store/models/entity/roleManagement/entity";
import { RoleManagementHelperModel } from "src/store/models/entity/roleManagement/helper";

export const encooRoleManagementModels = {
  entity: RoleManagementEntityModel,
  helper: RoleManagementHelperModel,
};
